<div id="editor" class="mx-1 mt-3" [froalaEditor]="options" [(froalaModel)]="frolaFormula"></div>
